module.exports = __webpack_public_path__ + "img/apple_icon.c66b5c1c.svg";